import { Component } from '@theme/component';

class LcVariantSwap extends Component {
  requiredRefs = ['host'];

  #selection = [];

  connectedCallback() {
    super.connectedCallback();

    const data = this.dataset;
    this.values = (data.lcSwapValues || '').split('||').map((list) => list.split('~'));
    this.current = (data.lcSwapCurrent || '').split('|');
    this.map = new Map(
      (data.lcSwapMap || '')
        .split(';')
        .filter(Boolean)
        .map((entry) => {
          const cut = entry.lastIndexOf(':');
          return [entry.slice(0, cut), entry.slice(cut + 1)];
        })
    );

    this.confirm = this.querySelector('.lc-vswap__confirm');
    this.hint = this.querySelector('.lc-vswap__hint');
    this.#selection = this.current.slice();
    this.addEventListener('click', this.#onAct);
    this.#paint();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#onAct);
  }

  #onAct = (event) => {
    const act = event.target.closest('[data-lc-swap-act]');
    if (act) {
      if (act.dataset.lcSwapAct === 'open') this.open();
      if (act.dataset.lcSwapAct === 'close') this.close();
      if (act.dataset.lcSwapAct === 'apply' && !act.disabled) this.apply();
      return;
    }
    const button = event.target.closest('[data-lc-swap-val]');
    if (!button || button.disabled) return;
    this.#selection[Number(button.dataset.lcSwapOpt)] = button.dataset.lcSwapVal;
    this.#paint();
  };

  #variantFor(index, value) {
    const trial = this.#selection.slice();
    if (index !== null) trial[index] = value;
    return this.map.get(trial.join('|'));
  }

  #paint() {
    for (const button of this.querySelectorAll('[data-lc-swap-val]')) {
      const index = Number(button.dataset.lcSwapOpt);
      const value = button.dataset.lcSwapVal;
      button.disabled = !this.#variantFor(index, value);
      button.setAttribute('aria-pressed', this.#selection[index] === value ? 'true' : 'false');
    }

    const target = this.#variantFor(null);
    const changed = this.#selection.join('|') !== this.current.join('|');
    const { confirm, hint } = this;
    const label = this.#selection.join(' · ');

    confirm.disabled = !target || !changed;

    if (!target) {
      confirm.textContent = this.dataset.lcSwapSoldout;
      hint.textContent = label;
      hint.setAttribute('data-lc-swap-bad', '');
      return;
    }

    confirm.textContent = changed ? `${this.dataset.lcSwapConfirm} · ${label}` : this.dataset.lcSwapConfirm;
    hint.textContent = '';
    hint.removeAttribute('data-lc-swap-bad');
  }

  open = () => {
    this.#selection = this.current.slice();
    this.#paint();
    this.refs.host.showDialog();
  };

  close = () => {
    this.refs.host.closeDialog();
  };

  apply = async () => {
    const target = this.#variantFor(null);
    if (!target) return;

    this.confirm.disabled = true;
    this.close();

    await Shopify.actions.updateCart({
      lines: [
        {
          id: this.dataset.lcSwapKey,
          merchandiseId: `gid://shopify/ProductVariant/${target}`,
          quantity: Number(this.dataset.lcSwapQty) || 1,
        },
      ],
    });
  };
}

if (!customElements.get('lc-variant-swap')) {
  customElements.define('lc-variant-swap', LcVariantSwap);
}
